<template>
  <div>
    <PageAllow controller="Examines" action="viewByAbnormal" />
    <Breadcrumbs :items="items" />
    <v-expansion-panels v-model="panels" multiple accordion>
      <v-expansion-panel>
        <v-expansion-panel-header>
          <v-card-title class="ms-n4 py-0">
            {{ $t("CRUD.info", [$t("Examine.ObjectName")]) }}
            <v-chip
              small
              label
              class="ms-4 mt-1"
              :color="examine.is_examined | examineStatusColor"
              :text-color="examine.is_examined | examineStatusTextColor"
              >{{ examine.is_examined | examineStatusText }}
            </v-chip>
            <v-spacer />
            <v-sheet class="pt-1 transparent-background-color d-inline-block">
              <v-btn
                v-if="savable"
                small
                dark
                outlined
                color="secondary"
                class="px-2 me-2 mb-1 elevation-1"
                @click.stop="$router.push('/examines/' + examine.id)"
              >
                <v-icon x-small class="pe-1">fa-times</v-icon>
                {{ $t("CRUD.backForModify") }}
              </v-btn>
              <v-btn
                v-if="
                  savable &&
                  $permission.permissionAllow('Examines', 'abnormalEdit')
                "
                small
                dark
                color="primary"
                class="px-2 me-2 mb-1"
                @click.stop="doSubmit('edit')"
              >
                <v-icon x-small class="pe-1">fa-save</v-icon>
                {{ $t("Examine.actions.examine_abnormal_edit") }}
              </v-btn>
              <v-btn
                v-if="
                  savable &&
                  $permission.permissionAllow('Examines', 'abnormalComplete')
                "
                small
                dark
                color="action"
                class="px-2 me-2 mb-1"
                @click.stop="doSubmit('complete')"
              >
                <v-icon x-small class="pe-1">fa-check</v-icon>
                {{ $t("Examine.actions.examine_finish") }}
              </v-btn>
            </v-sheet>
          </v-card-title>
        </v-expansion-panel-header>

        <v-expansion-panel-content>
          <v-divider />
          <v-row no-gutters class="mt-4 table-style">
            <v-col cols="12" md="4">
              <v-card class="pa-2 text-no-wrap" outlined tile>
                <span class="secondary--text">
                  {{ $t("Examine.DetailFields.examine_code")
                  }}{{ $t("Global.colon") }}
                </span>
                {{ examine.examine_code }}
              </v-card>
            </v-col>
            <v-col cols="12" md="4" class="d-none d-md-inline">
              <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                <span class="secondary--text">
                  {{ $t("Examine.DetailFields.order_code")
                  }}{{ $t("Global.colon") }}
                </span>
                <span>
                  {{ examine.order_code }}
                </span>
              </v-card>
            </v-col>
            <v-col cols="12" md="4">
              <v-card class="pa-2 text-no-wrap" outlined tile>
                <span class="secondary--text">
                  {{ $t("Examine.DetailFields.shop_name", [$consts.shopName()])
                  }}{{ $t("Global.colon") }}
                </span>
                {{ examine && examine.shop ? examine.shop.shop_name : "" }}
              </v-card>
            </v-col>
            <v-col cols="12" md="4">
              <v-card class="pa-2 text-no-wrap" outlined tile>
                <span class="secondary--text">
                  {{ $t("Examine.DetailFields.executor", [$consts.shopName()])
                  }}{{ $t("Global.colon") }}
                </span>
                {{ examine.examiner_name }}
              </v-card>
            </v-col>
            <v-col cols="12" md="4">
              <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                <span class="secondary--text">
                  {{ $t("Examine.DetailFields.examine_time")
                  }}{{ $t("Global.colon") }}
                </span>
                <span> {{ examine.examine_time | formatTime }}</span>
              </v-card>
            </v-col>
            <v-col cols="12" md="4">
              <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                <span class="secondary--text">
                  {{ $t("Examine.DetailFields.examiner")
                  }}{{ $t("Global.colon") }}
                </span>
                <span> {{ examine.examine_flg | examineFlgsText }}</span>
              </v-card>
            </v-col>
            <v-col cols="12" md="12">
              <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                <span class="secondary--text">
                  {{ $t("Examine.DetailFields.distribution_info")
                  }}{{ $t("Global.colon") }}
                </span>
                <span>
                  {{
                    (examine && examine.stock ? examine.stock.name : "") +
                    " - " +
                    examine.distribution_user_name
                  }}
                </span>
              </v-card>
            </v-col>
            <v-col cols="12" md="12">
              <v-card class="pa-2 text-no-wrap" outlined tile>
                <span class="secondary--text">
                  {{ $t("Examine.DetailFields.shop_name", [$consts.shopName()])
                  }}{{ $t("Global.colon") }}
                </span>
                {{ examine && examine.shop ? examine.shop.shop_name : "" }}
              </v-card>
            </v-col>
            <v-col cols="12" md="4">
              <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                <span class="secondary--text">
                  {{ $t("Examine.DetailFields.receiver")
                  }}{{ $t("Global.colon") }}
                </span>
                <span>
                  {{
                    receiverInfo
                      ? receiverInfo.user_name
                      : examine.shop_user_name
                  }}
                </span>
              </v-card>
            </v-col>
            <v-col cols="12" md="8">
              <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                <span class="secondary--text">
                  {{ $t("Examine.DetailFields.contact_number")
                  }}{{ $t("Global.colon") }}
                </span>
                <span>
                  {{
                    receiverInfo
                      ? receiverInfo.tel
                      : examine && examine.shop && examine.shop.shop_user
                      ? examine.shop.shop_user.tel
                      : ""
                  }}
                </span>
              </v-card>
            </v-col>
            <v-col cols="12" md="12">
              <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                <span class="secondary--text">
                  {{
                    $t("Examine.DetailFields.shop_address", [
                      $consts.shopName(),
                    ])
                  }}{{ $t("Global.colon") }}
                </span>
                <span v-if="receiverInfo">{{ receiverInfo.address }}</span>
                <AddressText
                  v-else
                  :masterItem="examine ? examine.shop : null"
                  :detailAddress="
                    examine && examine.shop ? examine.shop.address : ''
                  "
                />
              </v-card>
            </v-col>
            <v-col cols="12" sm="12" md="12">
              <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                <span class="secondary--text">
                  {{ $t("Examine.DetailFields.account_memo") }}{{ $t("Global.colon") }}
                </span>
                <span>
                  {{ examine.account_memo }}
                </span>
              </v-card>
            </v-col>
            <v-col cols="12" sm="12" md="12">
              <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                <span class="secondary--text">
                  {{ $t("Examine.DetailFields.memo") }}
                  {{ $t("Global.colon") }}
                </span>
                <v-text-field
                  v-if="savable"
                  v-model="examine.memo"
                  single-line
                  dense
                  hide-details
                  class="d-inline mt-0 mb-n1"
                />
                <span v-else style="overflow-wrap: break-word;white-space: pre-wrap">
                  {{ examine.memo }}
                </span>
              </v-card>
            </v-col>
            <v-col cols="12" sm="12" md="12">
              <v-card class="pa-2 d-flex overflow-auto align-end" outlined tile>
                <!-- 附件 -->
                <span class="secondary--text text-no-wrap">
                  {{ $t("Order.Fields.attachments") }}{{ $t("Global.colon") }}
                </span>
                <!-- 上传附件1 -->
                <span class="ml-4">
                  <v-card v-if="img_one" width="140" height="100">
                    <v-img
                      :src="img_one"
                      @click.stop="$showFullscreenImages([img_one])"
                      v-if="
                        img_one.startsWith('data:image/') ||
                        ['jpg', 'jpeg', 'gif', 'png'].includes(
                          img_one
                            .substring(img_one.lastIndexOf('.') + 1)
                            .toLowerCase()
                        )
                      "
                      width="140"
                      height="100"
                    >
                      <v-tooltip right v-if="savable && img_one">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-bind="attrs"
                            v-on="on"
                            color="secondary"
                            class="pa-2 float-right"
                            @click.stop="
                              !img_one.startsWith('data:image/') &&
                              img_one == img_url_one
                                ? (img_url_one = img_one = null)
                                : (img_one = null)
                            "
                            >fa-times</v-icon
                          >
                        </template>
                        <span> {{ $t("Material.delImg") }}</span>
                      </v-tooltip>
                    </v-img>
                    <div v-else max-width="140" style="position: relative">
                      <span
                        style="
                          position: absolute;
                          top: 0;
                          right: 0;
                          z-index: 99;
                        "
                        @click.stop="
                          !img_one.startsWith('data:image/') &&
                          img_one == img_url_one
                            ? (img_url_one = img_one = null)
                            : (img_one = null)
                        "
                        v-if="savable && img_one"
                      >
                        <v-icon color="secondary" class="pa-2 float-right">
                          fa-times
                        </v-icon>
                      </span>
                      <video width="140" height="100" controls>
                        <source :src="img_one" type="video/mp4" />
                      </video>
                    </div>
                  </v-card>
                  <v-file-input
                    ref="img_file_one"
                    v-if="savable"
                    show-size
                    counter
                    small-chips
                    suffix
                    prepend-icon="fa-camera"
                    accept="image/png, image/jpeg"
                    persistent-hint
                    :placeholder="$t('Material.imgsPlaceholder')"
                    :hint="$t('Material.imgsHint')"
                    :rules="imgRules"
                    v-model="img_file_one"
                  />
                </span>
                <div v-if="!showImgTwoFlg && savable">
                  <v-btn
                    small
                    color="primary"
                    class="ms-1"
                    @click.stop="showImgTwoFlg = true"
                  >
                    <v-icon x-small class="pe-1">fa-plus</v-icon>
                  </v-btn>
                </div>
                <!-- 上传附件2 -->
                <span class="ml-4" v-if="showImgTwoFlg || isView">
                  <v-card v-if="img_two" width="140" height="100">
                    <v-img
                      :src="img_two"
                      @click.stop="$showFullscreenImages([img_two])"
                      v-if="
                        img_two.startsWith('data:image/') ||
                        ['jpg', 'jpeg', 'gif', 'png'].includes(
                          img_two
                            .substring(img_two.lastIndexOf('.') + 1)
                            .toLowerCase()
                        )
                      "
                      width="140"
                      height="100"
                    >
                      <v-tooltip right v-if="savable && img_two">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-bind="attrs"
                            v-on="on"
                            color="secondary"
                            class="pa-2 float-right"
                            @click.stop="
                              !img_two.startsWith('data:image/') &&
                              img_two == img_url_two
                                ? (img_url_two = img_two = null)
                                : (img_two = null)
                            "
                            >fa-times
                          </v-icon>
                        </template>
                        <span> {{ $t("Material.delImg") }}</span>
                      </v-tooltip>
                    </v-img>
                    <div
                      v-else
                      width="140"
                      height="100"
                      style="position: relative"
                    >
                      <span
                        style="
                          position: absolute;
                          top: 0;
                          right: 0;
                          z-index: 99;
                        "
                        @click.stop="
                          !img_two.startsWith('data:image/') &&
                          img_two == img_url_two
                            ? (img_url_two = img_two = null)
                            : (img_two = null)
                        "
                        v-if="savable && img_two"
                      >
                        <v-icon color="secondary" class="pa-2 float-right">
                          fa-times
                        </v-icon>
                      </span>
                      <video width="140" height="100" controls>
                        <source :src="img_two" type="video/mp4" />
                      </video>
                    </div>
                  </v-card>
                  <v-file-input
                    ref="img_file_two"
                    v-if="savable"
                    show-size
                    counter
                    small-chips
                    suffix
                    prepend-icon="fa-camera"
                    accept="image/png, image/jpeg"
                    persistent-hint
                    :placeholder="$t('Material.imgsPlaceholder')"
                    :hint="$t('Material.imgsHint')"
                    :rules="imgRules"
                    v-model="img_file_two"
                  />
                </span>
                <div v-if="showImgTwoFlg && !showImgThreeFlg && savable">
                  <v-btn
                    small
                    color="primary"
                    class="ms-1"
                    @click.stop="showImgThreeFlg = true"
                  >
                    <v-icon x-small class="pe-1">fa-plus</v-icon>
                  </v-btn>
                </div>
                <!-- 上传附件3 -->
                <span class="ml-4" v-if="showImgThreeFlg || isView">
                  <v-card v-if="img_three" width="140" height="100">
                    <v-img
                      :src="img_three"
                      @click.stop="$showFullscreenImages([img_three])"
                      v-if="
                        img_three.startsWith('data:image/') ||
                        ['jpg', 'jpeg', 'gif', 'png'].includes(
                          img_three
                            .substring(img_three.lastIndexOf('.') + 1)
                            .toLowerCase()
                        )
                      "
                      width="140"
                      height="100"
                    >
                      <v-tooltip right v-if="savable && img_three">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-bind="attrs"
                            v-on="on"
                            color="secondary"
                            class="pa-2 float-right"
                            @click.stop="
                              !img_three.startsWith('data:image/') &&
                              img_three == img_url_three
                                ? (img_url_three = img_three = null)
                                : (img_three = null)
                            "
                          >
                            fa-times
                          </v-icon>
                        </template>
                        <span> {{ $t("Material.delImg") }}</span>
                      </v-tooltip>
                    </v-img>
                    <div
                      v-else
                      width="140"
                      height="100"
                      style="position: relative"
                    >
                      <span
                        style="
                          position: absolute;
                          top: 0;
                          right: 0;
                          z-index: 99;
                        "
                        @click.stop="
                          !img_three.startsWith('data:image/') &&
                          img_three == img_url_three
                            ? (img_url_three = img_three = null)
                            : (img_three = null)
                        "
                        v-if="savable && img_three"
                      >
                        <v-icon color="secondary" class="pa-2 float-right">
                          fa-times
                        </v-icon>
                      </span>
                      <video width="140" height="100" controls>
                        <source :src="img_three" type="video/mp4" />
                      </video>
                    </div>
                  </v-card>
                  <v-file-input
                    ref="img_file_three"
                    v-if="savable"
                    show-size
                    counter
                    small-chips
                    suffix
                    prepend-icon="fa-camera"
                    accept="image/png, image/jpeg"
                    persistent-hint
                    :placeholder="$t('Material.imgsPlaceholder')"
                    :hint="$t('Material.imgsHint')"
                    :rules="imgRules"
                    v-model="img_file_three"
                  />
                </span>
              </v-card>
            </v-col>
            <v-col cols="12" sm="12" md="12">
              <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                <span class="secondary--text"
                  >{{ $t("Examine.DetailFields.abnormal_memo")
                  }}{{ $t("Global.colon") }}
                </span>
                <v-text-field
                  v-if="savable"
                  v-model="examine.abnormal_memo"
                  single-line
                  dense
                  hide-details
                  class="d-inline mt-0 mb-n1"
                />
                <span v-else>
                  {{ examine.abnormal_memo }}
                </span>
              </v-card>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header class="py-0">
          <v-tabs v-model="tab" background-color="transparent">
            <v-tab
              @click.stop="
                tab = 0;
                panels.find((p) => p == 1) ? null : panels.push(1);
              "
            >
              {{ $t("Distribution.actions.activities") }}
            </v-tab>
          </v-tabs>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-tabs-items v-model="tab">
            <v-tab-item>
              <v-card flat>
                <v-data-table
                  :headers="activitiesHeaders"
                  :items="examine_activities"
                  class="elevation-0"
                  disable-pagination
                  hide-default-footer
                >
                  <template v-slot:item.created="{ item }">
                    <span class="text-no-wrap">
                      {{ item.created | formatTime }}
                    </span>
                  </template>
                </v-data-table>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <v-data-table
      :headers="detailsHeaders"
      :items="examineDetails"
      :search="filter"
      disable-pagination
      hide-default-footer
      :no-data-text="$t('Order.DetailNoData')"
      class="elevation-2 px-4 mt-4"
    >
      <template v-slot:top>
        <v-toolbar flat class="transparent-background-color">
          <v-toolbar-title class="ms-n2">
            {{ $t("CRUD.details", [$t("Examine.ObjectName")]) }}
          </v-toolbar-title>
        </v-toolbar>
        <v-divider />
        <v-toolbar
          flat
          class="transparent-background-color"
          align-self="center"
        >
          <span class="caption secondary--text pt-2">
            {{
              $t(
                "$vuetify.dataFooter.pageText",
                examineDetails
                  ? [1, examineDetails.length, examineDetails.length]
                  : [0, 0, 0]
              )
            }}
          </span>
          <v-spacer />
          <v-row no-gutters class="me-n3">
            <v-spacer />
            <v-col cols="12" sm="9" md="8">
              <v-text-field
                v-model="filter"
                clearable
                hide-details
                :label="$t('Search.filter')"
              />
            </v-col>
          </v-row>
        </v-toolbar>
      </template>
      <template v-slot:item.material_name="{ item }">
        <span class="danger--text">
          {{ item.material_code + "/" + item.material_name }}
        </span>
      </template>
      <template v-slot:item.examine_num="{ item }">
        <span class="danger--text">
          {{ isView ? item.initial_examine_num : item.examine_num }}
        </span>
      </template>
      <template v-slot:item.add_num="{ item }">
        <NumberInput
          v-if="savable"
          v-model="item.add_num"
          :min="-item.examine_num"
          dense
        />
        <span v-else class="danger--text">
          {{ item.add_num }}
        </span>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import Examines from "@/api/examines";
import Files from "@/api/files";
import NumberInput from "@/components/plugins/NumberInput";

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    NumberInput,
  },
  computed: {
    isView() {
      return !this.mode || this.mode == "view";
    },
    savable() {
      return this.mode == "edit";
    },

    items() {
      var items = [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.orderManagement"),
          disabled: false,
          href: "/orders",
        },
        {
          text: i18n.t("Nav.examines"),
          disabled: false,
          href: "/examines",
        },
        {
          text: i18n.t("Nav.examineAbnormalDetail"),
          disabled: true,
        },
      ];

      return items;
    },

    detailsHeaders() {
      var headers = [
        {
          text: i18n.t("Examine.DetailFields.material_category"),
          align: "start",
          value: "category_name",
        },
        {
          text:
            i18n.t("Examine.DetailFields.material_code") +
            " / " +
            i18n.t("Examine.DetailFields.material_name"),
          align: "start",
          value: "material_name",
        },
        {
          text: i18n.t("Examine.DetailFields.apply_num"),
          align: "start",
          value: "order_num",
        },
        {
          text: i18n.t("Examine.DetailFields.distribute_num"),
          align: "start",
          value: "distribution_num",
        },
        {
          text: i18n.t("Examine.DetailFields.initial_examine_num"),
          align: "start",
          value: "examine_num",
        },
        {
          text: i18n.t("Examine.DetailFields.add_examine_num"),
          align: "center",
          value: "add_num",
        },
        {
          text: i18n.t("Examine.DetailFields.unit"),
          align: "end",
          value: "unit",
        },
        {
          text: i18n.t("Examine.DetailFields.price"),
          align: "end",
          value: "price",
        },
        {
          text: i18n.t("Examine.DetailFields.sum"),
          align: "end",
          value: "subtotal_price",
        },
      ];

      return headers;
    },

    activitiesHeaders: () => [
      {
        text: i18n.t("Examine.ActivityFields.created_time"),
        align: "start",
        sortable: false,
        value: "created",
      },
      {
        text: i18n.t("Examine.ActivityFields.content"),
        align: "start",
        sortable: false,
        value: "content",
      },
      {
        text: i18n.t("Examine.ActivityFields.operater"),
        align: "start",
        sortable: false,
        value: "operater_name",
      },
    ],

    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings", "accountUser"]),
  },

  data: () => ({
    panels: [0],
    tab: null,
    filter: "",
    mode: "",
    examine: {},
    examineDetails: [],
    examine_activities: [],
    receiverInfo: {},
    imgRules: [
      (value) =>
        !value || value.size < 10000000 || i18n.t("AccountAds.imgHint"),
    ],
    album: [],
    imgs_file: [],
    img_file_one: null,
    img_file_two: null,
    img_file_three: null,
    img_one: "",
    img_two: "",
    img_three: "",
    img_url_one: "",
    img_url_two: "",
    img_url_three: "",
    showImgTwoFlg: false,
    showImgThreeFlg: false,
  }),

  mounted() {
    if (this.$route.params.mode) {
      this.mode = this.$route.params.mode;
    } else {
      this.mode = "view";
    }
  },

  methods: {
    getExamineAbnormalDetailFromAPI() {
      Examines.abnormalDetail(this.$route.params.id, {
        order_activity: 1,
      }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.examine = response.data.examine;
            this.examineDetails = response.data.examine.examine_details;
            this.examine_activities = response.data.order_activities;
            this.receiverInfo = response.data.order_address;

            this.album = [];
            if (response.data.examine.examine_file_url.image_url) {
              response.data.examine.examine_file_url.image_url.forEach(
                (img) => {
                  this.album.push(img);
                }
              );
            }
            if (response.data.examine.examine_file_url.video_url) {
              response.data.examine.examine_file_url.video_url.forEach(
                (video) => {
                  this.album.push(video);
                }
              );
            }

            this.img_url_one = this.img_one =
              this.album && this.album[0] ? this.album[0] : "";
            this.img_url_two = this.img_two =
              this.album && this.album[1] ? this.album[1] : "";
            this.img_url_three = this.img_three =
              this.album && this.album[2] ? this.album[2] : "";
            if (this.album && this.album[1]) {
              this.showImgTwoFlg = true;
            }
            if (this.album && this.album[2]) {
              this.showImgThreeFlg = true;
            }
          }
        }.bind(this)
      );
    },

    async doSubmit(action) {
      this.$store.dispatch("fullscreenLoading");

      // 检查一下图片上传的error，拒绝上传
      if (this.$refs.img_file_one.hasError) {
        this.$store.dispatch("fullscreenLoadingStop");
        return;
      }
      if (this.$refs.img_file_two && this.$refs.img_file_two.hasError) {
        this.$store.dispatch("fullscreenLoadingStop");
        return;
      }
      if (this.$refs.img_file_three && this.$refs.img_file_three.hasError) {
        this.$store.dispatch("fullscreenLoadingStop");
        return;
      }
      //提交图片集
      let examine_img = [];
      let imgs_file = [];
      if (this.img_file_one) {
        imgs_file.push(this.img_file_one);
      } else if (this.img_one) {
        examine_img.push(
          this.img_one.substring(this.img_one.lastIndexOf("/") + 1)
        );
      }

      if (this.img_file_two) {
        imgs_file.push(this.img_file_two);
      } else if (this.img_two) {
        examine_img.push(
          this.img_two.substring(this.img_two.lastIndexOf("/") + 1)
        );
      }

      if (this.img_file_three) {
        imgs_file.push(this.img_file_three);
      } else if (this.img_three) {
        examine_img.push(
          this.img_three.substring(this.img_three.lastIndexOf("/") + 1)
        );
      }

      if (imgs_file && imgs_file.length > 0) {
        let response = await Files.filesUpload(imgs_file, "images");
        if (response.data.status.isOK()) {
          response.data.data.forEach((file) =>
            examine_img.push(file.file_name)
          );
        }
      }

      let examine_details = [];
      this.examineDetails.forEach((detail) => {
        examine_details.push({
          material_id: detail.material.id,
          add_num: detail.add_num,
          auto_flg: detail.auto_flg,
          unit: detail.unit,
        });
      });
      Examines.abnormalEdit(action, {
        id: this.examine.id,
        memo: this.examine.memo,
        abnormal_memo: this.examine.abnormal_memo,
        examine_img: examine_img,
        examine_details: examine_details,
      })
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.$router.push("/examines");
              this.$store.dispatch("fullscreenLoadingStop");
            } else {
              this.$store.dispatch("fullscreenLoadingStop");
            }
          }.bind(this)
        )
        .catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
    },
  },

  watch: {
    mode: {
      handler() {
        if (this.$route.params.id) this.getExamineAbnormalDetailFromAPI();
      },
    },
    examineDetails: {
      deep: true,
      handler() {
        this.examineDetails.forEach((detail) => {
          detail.distribution_num = parseFloat(detail.distribution_num).toFixed(
            2
          );
          detail.examine_num = parseFloat(detail.examine_num).toFixed(2);
          if (this.isView) {
            detail.add_num = parseFloat(detail.add_num).toFixed(2);
            detail.initial_examine_num = parseFloat(
              detail.examine_num - detail.add_num
            ).toFixed(2);
            detail.subtotal_price =
              parseFloat(detail.price) * parseFloat(detail.examine_num); //小计
          } else {
            detail.subtotal_price =
              parseFloat(detail.price) *
              (parseFloat(detail.examine_num) + parseFloat(detail.add_num)); //小计
          }

          detail.price = parseFloat(detail.price).toFixed(2);
        });
      },
    },
    img_one: {
      handler() {
        if (!this.img_one) {
          this.img_file_one = null;
        }
      },
    },
    img_file_one: {
      handler() {
        if (this.img_file_one) {
          var reader = new FileReader();
          reader.readAsDataURL(this.img_file_one);
          let that = this;
          reader.onload = function () {
            that.img_one = this.result;
          };
        } else {
          this.img_one = this.img_url_one;
        }
      },
    },
    img_two: {
      handler() {
        if (!this.img_two) {
          this.img_file_two = null;
        }
      },
    },
    img_file_two: {
      handler() {
        if (this.img_file_two) {
          var reader = new FileReader();
          reader.readAsDataURL(this.img_file_two);
          let that = this;
          reader.onload = function () {
            that.img_two = this.result;
          };
        } else {
          this.img_two = this.img_url_two;
        }
      },
    },
    img_three: {
      handler() {
        if (!this.img_three) {
          this.img_file_three = null;
        }
      },
    },
    img_file_three: {
      handler() {
        if (this.img_file_three) {
          var reader = new FileReader();
          reader.readAsDataURL(this.img_file_three);
          let that = this;
          reader.onload = function () {
            that.img_three = this.result;
          };
        } else {
          this.img_three = this.img_url_three;
        }
      },
    },
  },
};
</script>